/* UI-158: Refresh only recent-card artwork from the public product endpoint.
 * Never use cached image URLs as the sole source after a merchant replaces media.
 */
(() => {
  'use strict';
  function imageURL(value) {
    if (typeof value !== 'string' || !value) return null;
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:' ||
          !(url.origin === location.origin || url.hostname === 'cdn.shopify.com')) return null;
      url.searchParams.set('width', '533');
      return url.href;
    } catch (_) { return null; }
  }
  function productURL(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/[a-z0-9-]+\/?$/.test(url.pathname)) return null;
      return url.origin + url.pathname.replace(/\/$/, '') + '.js';
    } catch (_) { return null; }
  }
  function refresh(root) {
    if (!root) return;
    root.querySelectorAll('a.producturl').forEach(link => {
      const img = link.querySelector('img');
      const endpoint = productURL(link.getAttribute('href'));
      if (!img || !endpoint) return;
      const hideBroken = () => { img.style.visibility = 'hidden'; };
      img.addEventListener('error', hideBroken);
      img.addEventListener('load', () => { img.style.visibility = ''; });
      if (img.complete && !img.naturalWidth) hideBroken();
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);
      fetch(endpoint, { credentials: 'same-origin', signal: controller.signal })
        .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(product => {
          const src = imageURL(product.featured_image || (product.images && product.images[0]));
          if (!src) return;
          // Remove stale srcset as well: it otherwise overrides a repaired src.
          img.removeAttribute('srcset');
          img.src = src;
          img.alt = product.title || '';
        })
        .catch(() => { /* Keep usable cached artwork on temporary request failures. */ })
        .finally(() => clearTimeout(timer));
    });
  }
  window.BWRecentImages = { refresh };
})();
